import { baseUrl, getTokenFromLocalStorage } from "./Configuration";

export async function getCurrentAssistant() {
  const res = await fetch(`${baseUrl}/api/assistant/current`, {
    headers: {
      Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
    },
  });
  if (res.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
    return;
  }
  if (!res.ok) {
    if (res.status === 404) {
      return { assistantId: null };
    }
    throw new Error("Failed to fetch current assistant");
  }
  return res.json();
}

export async function uploadPdfAndCreateAssistant(file: File) {
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`${baseUrl}/api/assistant/upload-pdf`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
    },
    body: formData,
  });
  if (res.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
    return;
  }
  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.error || "Failed to upload PDF");
  }
  return res.json();
}
